import { forwardRef, useEffect, useState } from 'react';

interface DebouncedInputProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly debounce?: number;
}

const DebouncedInput = forwardRef(
  (
    {
      value: initialValue,
      onChange,
      debounce = 500,
      ...props
    }: DebouncedInputProps &
      Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>,
    ref?: React.Ref<HTMLInputElement>,
  ) => {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
      setValue(initialValue);
    }, [initialValue]);

    useEffect(() => {
      const timeout = setTimeout(() => {
        onChange(value);
      }, debounce);

      return () => clearTimeout(timeout);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return (
      <input
        {...props}
        ref={ref}
        value={value ?? ''}
        onChange={(e) => setValue(() => e.target.value)}
      />
    );
  },
);

export default DebouncedInput;
